/**
 * Interview meeting-link rule, mirrored from the API (`meeting-link.ts`):
 * blank = no link yet; otherwise an absolute http(s) URL with a host. The
 * listener app opens it in a browser, so anything else is refused up front
 * instead of arriving as a dead Join button.
 */
export function meetingLinkError(raw: string | undefined | null): string | null {
  const v = (raw ?? '').trim();
  if (!v) return null;
  try {
    const u = new URL(v);
    if ((u.protocol === 'https:' || u.protocol === 'http:') && u.hostname) return null;
  } catch {
    /* fall through */
  }
  return 'Enter a full link starting with https:// (e.g. https://meet.google.com/abc-defg-hij)';
}
